import request from "../request"
//查询标头树

export function getResouces() {
  let data={
    cType:2,
    columnPid:7
  }
  return request({
    url: '/columns/',
    method:'get',
    params:data
  })
}

export function getcolumnsList(data) {
  return request({
    url: '/columns/list',
    method:'get',
    params:data
  })
}

export function getnewList(query) {
  return request({
    url: '/news/',
    method: 'get',
    params: query
  })
}

export function getplugList(data) {
  return request({
    url: '/plug/',
    method:'get',
    params:data
  })
}



// WEBPACK FOOTER //
// ./src/api/resouces.js